<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.99728 23.1622C6.6077 22.3196 4.83401 19.237 4.83401 16.6166C4.83401 13.5438 7.70473 11.2044 8.37477 10.0151C9.0448 8.82576 10.7724 5.21421 9.8199 1C9.8199 1 13.4459 3.88803 14.5561 6.76624C15.8699 10.1802 14.5824 13.8212 14.5824 13.8212C14.5824 13.8212 15.5282 13.912 16.3034 13.4327C17.0522 12.9669 17.5779 12.0808 17.5779 12.0808C17.5779 12.0808 19.4696 13.3935 19.3054 16.4324C19.174 19.0069 17.2625 22.2202 13.8663 23.1309C14.2473 22.6755 14.5299 22.0901 14.6153 21.4205C14.8255 19.7225 13.3605 18.9069 12.7168 17.5715C12.073 16.2355 12.881 14.5251 12.881 14.5251C11.6132 15.3573 8.93958 17.3726 8.91331 20.1496C8.90017 21.5224 9.3798 22.508 9.99728 23.1622Z"
  />
</template>
